// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedOutBucketingBar-cls1_SDq","cls2":"LoggedOutBucketingBar-cls2_KFA LoggedOutBucketingBar-cls1_SDq"};